<svelte:options tag="question-mark" />

<div id="question-mark-actions" class="action-btn">
  <!-- Question Mark  -->
  <svg
    id="question-icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="overflow: visible; enable-background: new 0 0 512 512;"
    xml:space="preserve"
    on:touchstart={toggleHelp}
    on:click={toggleHelp}
    aria-label="question icon"
  >
    <style type="text/css">
      .st0 {
        fill: var(--ripe-app-header-icon-bg, #c0c0c0);
      }
      .st1 {
        fill: #ffffff;
      }
    </style>
    <defs />
    <circle class="hover-ring" cx="256" cy="256" r="256" />
    <path
      class="st0"
      d="M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256S114.6,0,256,0S512,114.6,512,256z M272.1,287v-7.4
        c0-4.9,1-8.9,3.1-11.9c2.1-3,7.1-7.5,15-13.3c11.5-8.2,19.3-15.6,23.4-22.1c4.1-6.6,6.2-14.4,6.2-23.4c0-13.5-5-24.4-15-32.5
        c-10-8.1-23.4-12.2-40.3-12.2c-20.5,0-39.9,5.1-58.2,15.4l13.4,26.9c15.8-8,29.8-12.1,42.1-12.1c7.1,0,12.6,1.4,16.5,4.2
        c3.9,2.8,5.9,6.9,5.9,12.2c0,4.8-1.4,9.1-4.1,12.9c-2.8,3.9-8.4,8.9-17,15c-8.9,6.6-15.1,12.8-18.5,18.6c-3.4,5.8-5,12.7-5,20.6v9.1
        H272.1z
        M241.2,344.5c3.8,3.6,9.1,5.5,16,5.5c6.7,0,12-1.9,15.8-5.6c3.8-3.7,5.7-8.8,5.7-15.3c0-6.7-1.9-11.9-5.6-15.5
        c-3.7-3.6-9-5.4-15.8-5.4c-7.1,0-12.4,1.8-16.1,5.3c-3.7,3.5-5.5,8.7-5.5,15.6C235.6,335.7,237.5,340.9,241.2,344.5z"
    />
  </svg>
  <slot />
</div>

<script>
  import { get_current_component } from 'svelte/internal'

  const component = get_current_component()

  const toggleHelp = e => {
    e.preventDefault()
    const event = new CustomEvent('ripe-app-question-click', {
      bubbles: true,
      cancelable: true,
      composed: true,
    })
    component.dispatchEvent(event)
  }
</script>

<style type="text/scss">
  :host {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;
    position: relative;
    background: none;
    font-family: var(--ripe-app-font-family), Helvetica, Arial, Sans-serif;
    font-weight: 400;
    user-select: none;
    // pff, this should gap on the parent.
    // but chromium can't deal with it yet.
    margin-left: 1rem;
  }

  #question-icon {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;

    circle.hover-ring {
      fill: none;
      stroke: none;
    }

    &:hover {
      cursor: pointer;
    }
  }

  button {
    border: none;
    background: none;
    padding: 0;
  }

  ::slotted(roll-over) {
    position: absolute;
    /* the safety hover-overlap starts
      working below 'top' */
    top: 25px;
    right: -9px;
    width: 312px;
    z-index: 1;
  }

  #question-mark-actions:hover circle.hover-ring {
    stroke: none;
    fill: var(--ripe-app-header-icon-hover, #131f48);
    transform: scale(1.25);
    transform-origin: 256px 256px;
    transition: 0.1s transform ease-in;
  }

  #question-mark-actions ::slotted(roll-over) {
    display: none;
  }

  #question-mark-actions:hover ::slotted(roll-over) {
    display: block;
  }

  @media print {
    #question-mark-actions {
      display: none;
    }
  }
</style>
